<template>
  <v-select
    v-model="selected"
    dense
    outlined
    item-text="text"
    item-value="value"
    :disabled="disabled"
    :items="items"
  >
    <template #label>
      <span
        class="info--text"
        v-text="label"
      />
    </template>
  </v-select>
</template>

<script>
export default {
  name: 'BaseFormSelect',
  props: {
    value: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    selected: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>
